module.exports = __webpack_public_path__ + "img/national-qualification-level-2.a9e5c2d8.jpg";